<div *ngIf="template">
  <form #templateForm="ngForm">
    <div class="form-row">
      <div class="form-group col-xs-12 col-sm-12 col-lg-6">
        <label for="name">Nome</label>
        <input class="form-control" type="text" id="name" name="name" [(ngModel)]="template.name" #name="ngModel" required minlength="10" maxlength="250" />
        <div *ngIf="name.invalid && (name.dirty || name.touched)" class="text-danger">
          <small>
            <div *ngIf="name.errors.required">Nome é obrigatório</div>
            <div *ngIf="name.errors.minlength">Nome deve ter no mínimo 10 caracteres</div>
            <div *ngIf="name.errors.maxlength">Nome deve ter no máximo 250 caracteres</div>
          </small>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Texto</label>
      <quill-editor [styles]="{ height: '200px' }" id="text" name="text" [(ngModel)]="template.text" #text="ngModel" required minlength="16" maxlength="60000"></quill-editor>
        <div *ngIf="text.invalid && (text.dirty || text.touched)" class="text-danger">
          <small>
            <div *ngIf="text.errors.required">Texto é obrigatório</div>
            <div *ngIf="text.errors.minlength">Texto deve ter no mínimo 10 caracteres</div>
            <div *ngIf="text.errors.maxlength">Texto deve ter no máximo 250 caracteres</div>
          </small>
        </div>
    </div>
    <div class="float-right mt-3 mb-2">
      <button class="btn btn-secondary mr-1" (click)="cancel()">Cancelar</button>
      <button class="btn btn-primary mr-1" [disabled]="!templateForm.form.valid" (click)="save()">Salvar</button>
    </div>
  </form>
</div>
